import React from "react";
import { useLogs } from "../context/LogContext";
import "../styles.css";

const LogPanel = () => {
  const { logs } = useLogs();
  const reversedLogs = [...logs].reverse();

  return (
    <div className="log-panel">
      <h3>Activity Logs</h3>
      <div className="log-content">
        {reversedLogs.map((l, i) => {
          // Backward compatible: if any code ever pushed plain strings
          if (typeof l === "string") return <div key={i}>{l}</div>;

          if (l?.type === "break") {
            return <div key={i} style={{ height: 10 }} />;
          }

          if (l?.type === "image") {
            return (
              <div key={i} style={{ marginBottom: 12 }}>
                <div style={{ marginBottom: 6 }}>
                  [{l.time}] {l.caption}
                </div>
                <img
                  src={l.src}
                  alt={l.caption}
                  style={{
                    width: 220,
                    maxWidth: "100%",
                    height: "auto",
                    maxHeight: 160,
                    objectFit: "cover",
                    borderRadius: 10,
                    border: "1px solid rgba(0, 188, 212, 0.35)",
                    display: "block",
                  }}
                />
              </div>
            );
          }

          return (
            <div key={i}>
              [{l.time}] {l.message}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default LogPanel;
